
import {writable} from 'svelte/store';

const store = writable([]);

store.getAll = async (appId, filter = '') => {
    const res = await fetch(`api/v1/app-settings/geolocations/${appId}?filter=${filter}`);
    const userProfiles = await res.json();
    if(res.ok) {
        store.set(userProfiles);
    } else {
        store.set([]);
    }
}

export default store;
